import { FunctionComponent } from 'react';
import PageSpinner from 'src/designSystem/PageSpinner';

type Props = {
  spinner?: boolean;
};

const BootPlaceholder: FunctionComponent<Props> = ({ spinner = false }) => (
  <div
    data-testid="boot-placeholder"
    className="fixed inset-0 bg-primary-darkest"
  >
    {spinner && <PageSpinner type="white" />}
  </div>
);

export default BootPlaceholder;
